import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import i18n from 'i18next';

import { Button } from 'uikit/buttons';
import { Typo } from 'uikit/content';

import styles from '../styles/versioningListItem.module.scss';

const VersioningListItem = ({ item = {}, onClick = () => {} }) => {
  const { is_current_published: isPublished } = item;
  const labelKey = isPublished ? 'published-label' : 'archived-label';
  const { lang } = document.documentElement || 'en';

  const dateTime = new Date(item.version_state_updated_at).toLocaleString(lang, {
    dateStyle: 'short',
    timeStyle: 'short',
  });

  return (
    <div className={styles.element}>
      <div className={styles.column}>
        <Button
          className={classnames(styles.hasDot, isPublished && styles.isPublished)}
          onClick={() => onClick(item)}
          text={i18n.t('version-number', { number: item.version_number })}
          variant="link"
        />
      </div>
      <Typo className={styles.column} color="secondary" variant="s02">
        {i18n.t(labelKey, { author: item.version_state_updated_by, dateTime })}
      </Typo>
    </div>
  );
};

VersioningListItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
    is_current_published: PropTypes.bool,
    version_number: PropTypes.number,
    version_state_updated_at: PropTypes.string,
    version_state_updated_by: PropTypes.string,
  }),
  onClick: PropTypes.func,
};

export default React.memo(VersioningListItem);
